import Headroom from 'headroom.js/dist/headroom';
window.Headroom = Headroom;
import 'headroom.js/dist/jQuery.headroom.js';

$(window).on('load', function() {
  var navClass;
  navClass = '.headroom';
  if ($(navClass).length) {
    return $.each($(navClass), function() {
      var $nav, navPos;
      $nav = $(this);
      navPos = $nav.offset().top;
      return $nav.headroom({
        offset: navPos
      });
    });
  }
});

// ---
// generated by coffee-script 1.9.2
